import { createMap, forMember, mapFrom, constructUsing } from "@automapper/core";
import { BonusCodeDetails } from "../../contract/pam.js";
import { BonusCodeDetailsViewModelKeysTypeName, BonusCodeQueryFieldsTypeName } from "./constants.js";
import { BonusCodeDetailsViewModel } from "./types.js";
class BonusCodeMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      BonusCodeDetails,
      BonusCodeDetailsViewModel,
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m.bonus_id)
      ),
      forMember(
        (vm) => vm.bonus_id,
        mapFrom((m) => m.bonus_id)
      ),
      forMember(
        (vm) => vm.bonus_name,
        mapFrom((m) => m.bonus_name)
      ),
      forMember(
        (vm) => vm.bonus_status,
        mapFrom((m) => m.bonus_status)
      ),
      forMember(
        (vm) => vm.bonus_to_credit,
        mapFrom((m) => m.bonus_to_credit)
      ),
      forMember(
        (vm) => vm.create_time,
        mapFrom((m) => m.create_time)
      ),
      forMember(
        (vm) => vm.credit_type,
        mapFrom((m) => m.credit_type)
      ),
      forMember(
        (vm) => vm.description,
        mapFrom((m) => m.description)
      ),
      forMember(
        (vm) => vm.end_time,
        mapFrom((m) => m.end_time)
      ),
      forMember(
        (vm) => vm.last_update,
        mapFrom((m) => m.last_update)
      ),
      forMember(
        (vm) => vm.marketing_codes,
        mapFrom((m) => m.marketing_codes)
      ),
      forMember(
        (vm) => vm.meta,
        mapFrom((m) => m.meta)
      ),
      forMember(
        (vm) => vm.platform,
        mapFrom((m) => m.platform)
      ),
      forMember(
        (vm) => vm.release_mechanism,
        mapFrom((m) => m.release_mechanism)
      ),
      forMember(
        (vm) => vm.release_metric,
        mapFrom((m) => m.release_metric)
      ),
      forMember(
        (vm) => vm.release_ratio_type,
        mapFrom((m) => m.release_ratio_type)
      ),
      forMember(
        (vm) => vm.start_time,
        mapFrom((m) => m.start_time)
      ),
      forMember(
        (vm) => vm.threshold,
        mapFrom((m) => m.threshold)
      ),
      forMember(
        (vm) => vm.total_paid_out_amount,
        mapFrom((m) => m.total_paid_out_amount)
      ),
      forMember(
        (vm) => vm.created_by,
        mapFrom((m) => m.created_by ?? "")
      )
    );
    createMap(
      mapper,
      BonusCodeDetailsViewModelKeysTypeName,
      BonusCodeQueryFieldsTypeName,
      constructUsing((m) => {
        const mapper2 = {
          id: "bonus_id",
          bonus_id: "bonus_id",
          bonus_name: "bonus_name",
          bonus_status: "bonus_status",
          bonus_to_credit: "bonus_to_credit",
          "create_time.seconds": "create_time.seconds",
          credit_type: "credit_type",
          description: "description",
          end_time: "end_time",
          last_update: "last_update",
          marketing_codes: "marketing_codes",
          "meta.bonus_value_param": "meta.bonus_value_param",
          "meta.casino_excluded": "meta.casino_excluded",
          "meta.casino_included": "meta.casino_included",
          "meta.expire_period": "meta.expire_period",
          "meta.max_bonus_get": "meta.max_bonus_get",
          "meta.metric_amount": "meta.metric_amount",
          "meta.metric_qualify": "meta.metric_qualify",
          "meta.min_deposit": "meta.min_deposit",
          "meta.overall_max_bonus_get": "meta.overall_max_bonus_get",
          "meta.rake_amount": "meta.rake_amount",
          "meta.rake_qualify": "meta.rake_qualify",
          "meta.release_ratios": "meta.release_ratios",
          "meta.show_max_bonus_in_total": "meta.show_max_bonus_in_total",
          "meta.ticket_serial": "meta.ticket_serial",
          "meta.time_range_by_date": "meta.time_range_by_date",
          "meta.total_max_bonus_get": "meta.total_max_bonus_get",
          "meta.unrealized_expire_period": "meta.unrealized_expire_period",
          platform: "platform",
          release_mechanism: "release_mechanism",
          release_metric: "release_metric",
          release_ratio_type: "release_ratio_type",
          start_time: "start_time",
          threshold: "threshold",
          total_paid_out_amount: "total_paid_out_amount",
          created_by: "created_by"
        };
        return mapper2[m];
      })
    );
  }
}
export {
  BonusCodeMapping
};
//# sourceMappingURL=mapper.js.map
